import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().url(),
  // Opcional: se ausente, derivamos a partir do VITE_API_URL (mesmo host,
  // removendo o sufixo /api/v1). Evita misconfig durante o deploy quando
  // alguem esquece de setar a variavel separada para o socket.
  VITE_SOCKET_URL: z.string().url().optional(),
  VITE_APP_NAME: z.string().min(1),
  VITE_USE_MOCKS: z
    .union([z.literal('true'), z.literal('false'), z.undefined()])
    .transform((v) => v === 'true')
    .default('false'),
});

const parsed = envSchema.safeParse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_SOCKET_URL: import.meta.env.VITE_SOCKET_URL,
  VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
  VITE_USE_MOCKS: import.meta.env.VITE_USE_MOCKS,
});

if (!parsed.success) {
  console.error('Variaveis de ambiente invalidas:', parsed.error.flatten().fieldErrors);
  throw new Error('Variaveis de ambiente invalidas. Verifique seu .env');
}

const deriveSocketUrl = (apiUrl: string): string => {
  const url = new URL(apiUrl);
  return `${url.protocol}//${url.host}`;
};

export const env = {
  ...parsed.data,
  VITE_SOCKET_URL: parsed.data.VITE_SOCKET_URL ?? deriveSocketUrl(parsed.data.VITE_API_URL),
};
